import { useSearchActions } from './useSearchActions';
import { useSearchState } from './useSearchState';

export const useSearchReducer = () => ({
  ...useSearchActions(),
  isShowing: useSearchState(),
});
